<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">Liste yükleniyor</div>
							</div>
						</template>
						<template v-if="!isLoading">
							<v-toolbar color="indigo" dark>
								<v-text-field flat solo-inverted hide-details prepend-inner-icon="search" v-model="filterText" label="Ara"></v-text-field>
								<v-btn icon @click="newItem()">
									<v-icon>add_circle</v-icon>
								</v-btn>
							</v-toolbar>
  
							<v-list >
								<template v-for="(item, itemIndex) in getItems"> 
									<v-list-tile :key="itemIndex" avatar @click="editItem(item)" >  
										<v-list-tile-content>
											<v-list-tile-title> {{item.name}} </v-list-tile-title>  
										</v-list-tile-content>
									</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>

 




			</v-layout>
		</v-container>
	</v-content>


</template>


<script> 
	export default {
		name: "DesignSiteIndex",
		components : { 
		},
		data() {
			return {
				isLoading : true, 
				filterText : "", 
				items : [],
				 
			}
		},
		mounted(){
			this.loadItems();
		},
		methods : {
			loadItems(){
				this.isLoading = true; 
				this.$http.get( process.env.VUE_APP_API_URL + "/design/site/", {
					params : { }
				}).then(response => {  
					this.items = response.body;
					this.isLoading = false; 
				}) 
			},
			newItem(){ 
				this.$router.push({ 
					path: '/design/site/edit', query: { id: "" } 
				})
			},
			editItem(item){ 
				this.$router.push({ 
					path: '/design/site/edit', query: { id: item.id } 
				})
			}
		},
		computed : { 
			getItems(){
				var items = [];
				var filterText = this.filterText.toLowerCase(); 
				items = this.items.filter( function(item) { 
					if( filterText != ""){
						if( item.name.indexOf(filterText) < 0 ){ return false; }
					}
					return true;
				})  
				items.sort(function(a, b) {
					var nameA = a.name.toUpperCase(); 
					var nameB = b.name.toUpperCase(); 
					if (nameA < nameB) { return -1; }
					if (nameA > nameB) { return 1; } 
					return 0;
				});
				return items;
			}
		}
	}
</script>


